let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kUU4x")).then(() => parcelRequire('2RBjO'));